import styled from 'styled-components'

export const MessageStrongStyled = styled.strong`
  font-weight: ${(props) => props.theme.fontWeights.bold};
`
